// =============================================================================
// main.ts — Ponto de entrada do cliente (empacotado pelo esbuild p/ /js/main.js).
// =============================================================================
import { GameApp } from './app/GameApp';

new GameApp().start();
